<template>
    <div class="categ_info" v-if="obj_to_null(this.cur_item)">
        <info_field f_uniq="ct"
                    f_type="title"
                    :is_disabled="false"
                    @update_categ="change_atr"
                    :f_title="__t('NAME')"
                    :f_val="cur_item.title">

        </info_field>

        <info_field
            f_uniq="cid"
            f_type="uniq_id"
            :is_disabled="false"
            @update_categ="change_atr"
            :f_title="__t('UNIQ_PROV_CODE')"
            :f_val="cur_item.uniq_id">
        </info_field>

        <info_field
            f_uniq="cid_min"
            f_type="min_qual"
            :is_disabled="false"
            @update_categ="change_atr"
            :f_title="__t('MIN_QUAL')"
            :f_val="cur_item.min_qual">
        </info_field>

        <info_field
            f_uniq="cid_max"
            f_type="max_qual"
            :is_disabled="false"
            @update_categ="change_atr"
            :f_title="__t('MAX_QUAL')"
            :f_val="cur_item.max_qual">
        </info_field>

        <info_field
            f_uniq="cid_ordering"
            f_type="ordering"
            :is_disabled="false"
            @update_categ="change_atr"
            :f_title="__t('ORDERING')"
            :f_val="cur_item.ordering">
        </info_field>

        <info_field
            f_uniq="cid3"
            :f_title="__t('UNIQ_ID_CODE')"
            :f_val="cur_item.id.toString()">
        </info_field>


        <h5 class="frame-heading">{{__t("PUBLISHED_TTL")}}</h5>
        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" @change="change_atr('published',cur_item.published)" v-model="cur_item.published" class="custom-control-input" id="publish">
            <label class="custom-control-label" for="publish">{{__t("PUBLISHED")}}</label>
        </div>
    </div>

</template>

<script>
    import Info_field from "../../../../sys/info_field.vue";

    export default {
        name: "group_info",
        components: {Info_field},
        props : {
            group : {
                type : Object
            }
        },
        data() {
            return {
                cur_item : this.group,
                is_load: false,
            }
        },
        methods :  {
            change_atr(atr_name,atr_val) {

                this.$emit('on_group_change',{
                    "type"      : atr_name,
                    "value"     : atr_val,
                })
            }
        },
        computed : {
            is_disabled () {
                return this.cur_item.id > 0;
            },
        },
    }
</script>

<style scoped>

</style>
